module.exports = __webpack_public_path__ + "media/סולם.1b4c0e5d.mp3";